/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ForfeitLadderChallengeBody
 */
export interface ForfeitLadderChallengeBody {
    /**
     * Optional reason for forfeiting the challenge
     * @type {string}
     * @memberof ForfeitLadderChallengeBody
     */
    reason?: string;
}

/**
 * Check if a given object implements the ForfeitLadderChallengeBody interface.
 */
export function instanceOfForfeitLadderChallengeBody(value: object): value is ForfeitLadderChallengeBody {
    return true;
}

export function ForfeitLadderChallengeBodyFromJSON(json: any): ForfeitLadderChallengeBody {
    return ForfeitLadderChallengeBodyFromJSONTyped(json, false);
}

export function ForfeitLadderChallengeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ForfeitLadderChallengeBody {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function ForfeitLadderChallengeBodyToJSON(json: any): ForfeitLadderChallengeBody {
    return ForfeitLadderChallengeBodyToJSONTyped(json, false);
}

export function ForfeitLadderChallengeBodyToJSONTyped(value?: ForfeitLadderChallengeBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
    };
}

